var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back"},[_c('div',{staticClass:"clip-message"},[_vm._v("클립보드 보드에 복사되었습니다.")])])}]

export { render, staticRenderFns }